export const ONE_SIGNAL_APP_ID = '8ae0953c-5c85-4acb-ad7f-9553f123a343';
export const GOOGLE_TAG_MANAGER_ID = 'G-4KVXJ2Z4JF';

// Font Families
export const DEFAULT_FONT_FAMILY = 'Stag Sans LC';
export const DEFAULT_FONT_FAMILY_SEMIBOLD = 'Stag Sans LC Semibold';
